module.exports = __webpack_public_path__ + "static/img/icon-powerbi.efb3cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report-imgs/icon-powerbi.png
// module id = EmU2
// module chunks = 3